export const GET_ALL_CHARACTERS = 'GET_ALL_CHARACTERS';
export const GET_BY_CATEGORIES = 'GET_BY_CATEGORIES';
export const GET_ALL_SPECIES = 'GET_ALL_SPECIES';
export const CLEAR_LIST = 'CLEAR_LIST';
export const GET_STATE = 'GET_STATE';
